import { render } from "./AppToaster.vue?vue&type=template&id=3a48c8ba&scoped=true&ts=true"
import script from "./AppToaster.vue?vue&type=script&lang=ts"
export * from "./AppToaster.vue?vue&type=script&lang=ts"

import "./AppToaster.vue?vue&type=style&index=0&id=3a48c8ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a48c8ba"]])

export default __exports__